module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_8004.3306177d.png";